import { render } from "./ProductListTile.vue?vue&type=template&id=5aa8a2fc&scoped=true&ts=true"
import script from "./ProductListTile.vue?vue&type=script&lang=ts"
export * from "./ProductListTile.vue?vue&type=script&lang=ts"

import "./ProductListTile.vue?vue&type=style&index=0&id=5aa8a2fc&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aa8a2fc"]])

export default __exports__